var _path, _path2, _path3, _path4, _path5, _circle;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgConfirmedProcess(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 34,
    height: 42,
    viewBox: "0 0 34 42",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.0006 5.0061H29.0006C30.0615 5.0061 31.0789 5.42753 31.8291 6.17768C32.5792 6.92782 33.0006 7.94524 33.0006 9.0061V37.0061C33.0006 38.067 32.5792 39.0844 31.8291 39.8345C31.0789 40.5847 30.0615 41.0061 29.0006 41.0061H5.00064C3.93977 41.0061 2.92236 40.5847 2.17221 39.8345C1.42207 39.0844 1.00064 38.067 1.00064 37.0061V9.0061C1.00064 7.94524 1.42207 6.92782 2.17221 6.17768C2.92236 5.42753 3.93977 5.0061 5.00064 5.0061H9.00064",
    fill: "#FDE8F2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M25.0006 5.0061H29.0006C30.0615 5.0061 31.0789 5.42753 31.8291 6.17768C32.5792 6.92782 33.0006 7.94524 33.0006 9.0061V37.0061C33.0006 38.067 32.5792 39.0844 31.8291 39.8345C31.0789 40.5847 30.0615 41.0061 29.0006 41.0061H5.00064C3.93977 41.0061 2.92236 40.5847 2.17221 39.8345C1.42207 39.0844 1.00064 38.067 1.00064 37.0061V9.0061C1.00064 7.94524 1.42207 6.92782 2.17221 6.17768C2.92236 5.42753 3.93977 5.0061 5.00064 5.0061H9.00064",
    stroke: "#EC187B",
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M33.0006 32.6103V36.9992C33.0006 38.06 32.5792 39.0775 31.8291 39.8276C31.0789 40.5778 30.0615 40.9992 29.0006 40.9992H5.00064C3.93977 40.9992 2.92236 40.5778 2.17221 39.8276C1.42207 39.0775 1.00064 38.06 1.00064 36.9992V32.6103H33.0006Z",
    fill: "#EC187B"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M23.0006 1.0022H11.0006C9.89607 1.0022 9.00064 1.89763 9.00064 3.0022V7.0022C9.00064 8.10677 9.89607 9.0022 11.0006 9.0022H23.0006C24.1052 9.0022 25.0006 8.10677 25.0006 7.0022V3.0022C25.0006 1.89763 24.1052 1.0022 23.0006 1.0022Z",
    fill: "#FDE8F2",
    stroke: "#EC187B",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M13.7339 22.7377L16.1339 25.3303L21.2006 20.6636",
    stroke: "#EC187B",
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 17.0013,
    cy: 22.9979,
    r: 7,
    stroke: "#EC187B",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfirmedProcess);
export default __webpack_public_path__ + "static/media/confirmedProcess.b746d6c54fe80de920a42815249d8223.svg";
export { ForwardRef as ReactComponent };